import * as React from 'react';
import { useSelector } from 'react-redux';

import { getLiftsText } from './utils';
import { Item } from '../../../components/bti_house_data/Item';
import { getTotalLiftCounts, getServiceLiftCounts, getPassengerLiftCounts } from '../../../selectors/bti';

export function Elevators() {
  const totalLiftCounts = useSelector(getTotalLiftCounts);
  const serviceLiftCounts = useSelector(getServiceLiftCounts);
  const passengerLiftCounts = useSelector(getPassengerLiftCounts);

  const lifts = getLiftsText(totalLiftCounts, serviceLiftCounts, passengerLiftCounts);

  return <Item name="Лифты" value={lifts} />;
}
